import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft as ArrowLeft } from 'react-icons/fi';
import { Button } from '../../../components/ui/Button';
import CreateEditPolicyModal from '../components/CreateEditPolicyModal';

const CreateEditPolicyPage = () => {
  const { policyId } = useParams();
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/cloudops/guardrails/policies');
  };

  const handleClose = () => {
    navigate('/cloudops/guardrails/policies');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Button
        variant="ghost"
        onClick={handleClose}
        className="mb-4"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Policies
      </Button>
      <CreateEditPolicyModal
        isOpen={true}
        onClose={handleClose}
        onSuccess={handleSuccess}
        policyId={policyId ?? null}
      />
    </div>
  );
};

export default CreateEditPolicyPage;

